<div class="page-container" [ngClass]="{'full-width': fullWidth}">
  <ng-content></ng-content>
</div>
